export const JobStatus = {
    PENDING: {
        id: 'PENDING',
        label: 'Pending'
    },
    READY_TO_PROCESS: {
        id: 'READY_TO_PROCESS',
        label: 'Ready to Process'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS',
        label: 'In Progress'
    },
    DONE: {
        id: 'DONE',
        label: 'Done'
    },
    DONE_WITH_ERROR: {
        id: 'DONE_WITH_ERROR',
        label: 'Done with Error'
    },
    ERROR: {
        id: 'ERROR',
        label: 'Data Have some Error'
    },
    IN_PROGRESS_RE_POST: {
        id: 'IN_PROGRESS_RE_POST',
        label: 'Re Post in Progress'
    },
} as const

export enum wizardStepType {
    BrowserFile,
    FunctionMap,
    ColumnsMap,
    ReviewAndUpload
}
export enum wizardStepActionType {
    next,
    back
}

export enum RdowizardStepType {
    BrowserFile,
    FunctionMap,
    SheetMap,
    // ColumnsMap,
    ReviewAndUpload
}

export enum DataType{
    INT,
    STRING,
    DATE,
    DATE_TIME,
    ANY,
    BOOLEAN,
    DECIMAL
}
export interface columnMap {
    Source: string,
    DestinationLabel: string,
    DestinationCode: string,
    isRequired: boolean;
    requiredInfo?: string;
    versions?: number[] | undefined;
    validation?: { type: { value: number | DataType, error_message: string } }
}
export interface sheet {
    name?: string,
    functionCode?: string
    columnMap?: columnMap[]
}
export interface sheetSet {
    name?: string,
    sourceColumnList?: any[],
    rowData?: any[][]
}
export interface FileUpload {
    file: File,
    totalSheet?: sheetSet[],
    selectedSheet?: sheet[]
}

export interface RdoFileUpload {
    file: File;
    fileType?: string;
    selectedSheet?: Array<{ name: string }>;
    totalSheet?: Array<{
        name: string;
        data: any[][];
        sourceColumnList: any[];
    }>;
}

export type MigrationType = 'Full' | 'Basic' | 'Customization'
export interface ReckonFunctionColumn {
    DesktopFunctionName: string
    ReckonOneFunctionName: string
    appCode: string
    sequence: number
    isBasicMigration: boolean
    isActivate: boolean
}